import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner({ size = 'medium' }) {
  return (
    <div className="loading-spinner-container">
      <div className={`loading-spinner ${size}`}>
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </div>
  );
}

export default LoadingSpinner;
